/**
 * Allows to use a <select> tag as a menu. Useful for mobile.
 *
 * Usage:
 *     <select class="cw-select-menu">
 *       <option data-url="/">Home</option>
 *       <option data-url="/about">About</option>
 *       ...
 *     </select>
 *
 * And done! By default applies to all elements with the class `cw-select-menu`.
 *
 * If you want to use it in a specific element you can with\
 *
 *     $('#my-select').selectMenu();
 */

(function($){
  'use strict';

  $.fn.selectMenu = function() {
    this.on('change', function() {
      var option = $(this).find(':selected');
      var url = option.data('url');

      if (url) {
        document.location = url;
      }
    });
  };

  $(document).ready(function() {
    $('.cw-select-menu').selectMenu();
  });

})(jQuery);
